module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "file_026"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0015-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "file_026"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_vm._v("This rare color shot shows an FF-1 modified to carry dual controls and redesignated FF-2. The unique out- and downward-folding main gear system developed by Grumman can be clearly seen. This type of gear was a part of every Grumman fighter up through the creation of the F4F Wildcat. This aircraft flew with a Naval Reserve unit based in St. Louis. "), _c('em', [_vm._v("U.S. Navy via Stan Piet")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d57e08f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/file_026.vue
// module id = 129
// module chunks = 0